import { render, staticRenderFns } from "./department-cascade.vue?vue&type=template&id=6898536e&"
import script from "./department-cascade.vue?vue&type=script&lang=js&"
export * from "./department-cascade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports